import {
  Gauge,
  UserCircle,
  UsersThree,
  HandHeart,
  Signature,
  Handshake,
  CalendarDots,
  ArrowsClockwise,
  CalendarBlank,
  Tree,
  Books,
  Heartbeat,
  ChartBar,
  Files,
  Notepad,
  UserCircleGear,
  BaseballHelmet,
  Baby,
  ChatCircleDots,
  Barbell,
  Target,
  MapPinSimpleArea,
  BookOpenText,
} from "@phosphor-icons/react";
import React from "react";

export interface NavItem {
  label: string;
  path: string;
  icon: React.ElementType;
}

export interface NavGroup {
  label: string;
  items: NavItem[];
}
export type SidebarConfig = (NavItem | NavGroup)[];

export const getSidebarConfig = (userPermissions: any): SidebarConfig => [
  {
    label: "Dashboard",
    path: "dashboard",
    icon: Gauge,
  },
  {
    label: "Demographics",
    items: [
      {
        label: "Client Profile",
        path: "profile",
        icon: UserCircle,
      },
      {
        label: "Care Team",
        path: "care-team",
        icon: UsersThree,
      },
    ],
  },
  {
    label: "Clinical Care",
    items: [
      {
        label: "Clinical Program",
        path: "clinical-program",
        icon: BookOpenText,
      },
      {
        label: "Care Plan",
        path: "care-plan",
        icon: Target,
      },
      {
        label: "Goals & Targets",
        path: "goals-targets",
        icon: MapPinSimpleArea,
      },
      {
        label: "Strengths & Areas of Need",
        path: "strengths-and-areas-of-need",
        icon: Barbell,
      },
      {
        label: "Assessments",
        path: "assessments",
        icon: ChartBar,
      },
    ],
  },
  {
    label: "Therapy Schedule",
    items: [
      {
        label: "Preliminary Therapy Hours",
        path: "preliminary-therapy-hours",
        icon: CalendarBlank,
      },
      {
        label: "Weekly Availability",
        path: "weekly-availability",
        icon: CalendarDots,
      },
      {
        label: "Make-up Preferences",
        path: "makeup-preferences",
        icon: ArrowsClockwise,
      },
    ],
  },
  {
    label: "Authorizations & Insurance",
    items: [
      {
        label: "Authorizations",
        path: "authorizations",
        icon: Handshake,
      },
      {
        label: "Insurance",
        path: "insurance",
        icon: HandHeart,
      },
      {
        label: "Financial Guarantor",
        path: "financial-guarantor",
        icon: Signature,
      },
    ],
  },
  {
    label: "Client & Family Background",
    items: [
      {
        label: "Home & Family Life",
        path: "home-family-life",
        icon: Tree,
      },
      {
        label: "Developmental Milestones",
        path: "developmental-milestones",
        icon: Baby,
      },
      {
        label: "Social Activities",
        path: "social-activities",
        icon: BaseballHelmet,
      },
      {
        label: "Education",
        path: "education",
        icon: Books,
      },
      {
        label: "Medical History",
        path: "medical-history",
        icon: Heartbeat,
      },
    ],
  },
  {
    label: "Other",
    items: [
      {
        label: "Documents",
        path: "documents",
        icon: Files,
      },
      ...(userPermissions?.view_email_log
        ? [
            {
              label: "Communication",
              path: "communication",
              icon: ChatCircleDots,
            },
          ]
        : []),
      {
        label: "Logs",
        path: "logs",
        icon: Notepad,
      },
      ...(userPermissions?.override_client_workflow_state
        ? [
            {
              label: "Account Settings",
              path: "account-settings",
              icon: UserCircleGear,
            },
          ]
        : []),
    ],
  },
];
